import './index.less';
import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import useDelayedFlag from '@src/utils/hooks/use-delayed-flag';
import CommonLoading from '@src/components/common-loading';
import Page from '@src/components/page';
import BackHomeLink from '@src/components/back-home-link';
import routeConfigs from '@src/pages/app-router/route-configs';
import MoBackpack from '@src/ui-components/mo-backpack';
import MoBottomTabs from '@src/ui-components/mo-bottom-tabs';
import BackpackStore from './store';

const styles = require('./index.less');

// Store 缺失奖励时，以一个稳定的无字段海报奖励 ViewModel 暴露给静态壳
const EMPTY_POSTER_REWARD_VIEW_MODEL = Object.freeze({});

const BackpackView = ({ store }) => {
  // 短于 300ms 的加载不渲染遮罩：缓存命中/快速响应不闪屏，慢请求照常出现
  const showLoading = useDelayedFlag(store.loadStatus === 'loading');
  return (
    <Page className={styles.root}>
      <BackHomeLink to={routeConfigs.MAIN.getFormatPath()} />
      <MoBackpack
        teamRewardStages={store.teamRewardStages}
        posterReward={store.reward || EMPTY_POSTER_REWARD_VIEW_MODEL}
        claimDisabled={store.claimDisabled}
        claiming={store.claiming}
        onClaim={store.handleClaimClick}
      >
        <MoBottomTabs activeRouteKey="BACKPACK" disabled={store.operationLocked} onNavigate={store.navigateByTab} />
      </MoBackpack>
      {store.accountInfoStore.getComponent()}
      {showLoading ? (
        <div className={styles.loading} data-name="背包加载中">
          <CommonLoading />
        </div>
      ) : null}
    </Page>
  );
};

const ObservedBackpackView = observer(BackpackView);

export const BackpackContent = () => {
  const store = useStore(() => new BackpackStore());
  return <ObservedBackpackView store={store} />;
};

export const Backpack = () => <BackpackContent />;

export default Backpack;
